export default {
  INTERNAL_SERVER_ERROR: 99,
  WRONG_USERNAME_OR_PASSWORD: 1,
  INVALID_RECAPTCHA_TOKEN: 3,
  EMAIL_IS_NOT_VERIFIED: 4,
  NEW_IP_DETECTED: 5,
  USER_IS_DEACTIVED: 6,
  FORGET_PASSWORD_EXCEED_LIMIT: 7,
  USER_NOT_FOUND: 8,
  AUTH_TOKEN_EXPIRED: 9,
  AUTH_TOKEN_INVALID: 10,
  UNAUTHORIZED: 11,
  NEW_PASSWORD_INVALID: 12,
  INCORRECT_PASSWORD: 13,
  USER_EXISTING: 14,
  CONFIRMATION_CODE_EXPIRED: 15,
  CONFIRMATION_CODE_INVALID: 16,
  TWO_FA_AREALDY_ENABLED: 17,
  TWO_FA_SECRET_NOT_FOUND: 18,
  TWO_FA_VERIFICATION_CODE_INVALID: 19,
  TWO_FA_IS_NOT_ENABLED: 20,
  TWO_FA_VERIFICATION_CODE_NOT_FOUND: 21,
  ADDRESS_EXISTING: 22,
  COIN_NETWORK_NOT_FOUND: 23,
  ID_NOT_FOUND: 24,
  CAN_NOT_BE_REMOVED: 25,
  INVALID_STATE: 26,
  RESOURCE_EXISTING: 27,
  INVALID_ADDRESS: 28,
  INVALID_TRANSACTION: 29,
  INVALID_INVITATION_CODE: 30,
  EXCEED_ACCOUNT_LIMIT: 31,
  NOT_SUPPORTED: 32,
  UNAGII_CASH_WALLET_NOT_FOUND: 33,
  EXCEED_REQUEST_RATE_LIMIT: 34,
  INVALID_API_KEY: 35,
  INVALID_SIGNATURE: 36,
  INVALID_PARAMS: 37,
  NO_ETHEREUM_CONNECTED: 38,
  CAN_NOT_CREATE_SCW: 39
};
